import { contentApi, zimbaApi, availabilityApi } from '@/infrastructure/Configuration'
import { DateFactory } from 'rhg-vue-common'
import moment from 'moment'
const ROOM_CAPACITY = 8

export default class DiscoveryService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getPromotion(promotionId) {
    const url = `${contentApi}/promotions/${promotionId}`
    const response = await this.httpClient.get(url)
    return response.data
  }

  async getHotels(hotelFilters, numHotels) {
    const url = `${zimbaApi}/hotels?${hotelFilters ? hotelFilters.concat('&') : ''}offset=0&limit=${numHotels}`

    const { data } = await this.httpClient.get(url)
    return data.hotels
  }

  async getDestinationHotels() {
    const url = `${zimbaApi}/hotels/coordinates`
    const { data } = await this.httpClient.get(url)
    const hotelsArray = Object.entries(data.hotels).map(([code, coordinates]) => ({
      code,
      coordinates: {
        latitude: coordinates.latitude,
        longitude: coordinates.longitude
      }
    }))
    return hotelsArray
  }

  async getDestinationsCityHotels(cityCode) {
    const url = `${contentApi}/destination/city/${cityCode}`
    const { data } = await this.httpClient.get(url)
    return data.hotels
  }

  async getDestinationsCountryHotels(countryCode) {
    const url = `${contentApi}/destination/country/${countryCode}`
    const { data } = await this.httpClient.get(url)
    return data.hotels
  }

  async validatePromocode(promocode) {
    const params = {
      searchType: 'voucher',
      code: promocode,
      getPromoCodeDetail: true
    }
    const queryParams = global.Utils.stringifyQueryParams(params)
    const url = `${availabilityApi}/special-rate-codes/validate?${queryParams}`
    const response = await this.httpClient.get(url)
    return response.data
  }

  async getPromotionsUrls(promotionIds) {
    const queryParams = global.Utils.stringifyQueryParams({ promotionIds }).replaceAll(/%2C/gi, ',')
    const url = `${contentApi}/promotions?${queryParams}`
    const response = await this.httpClient.get(url)
    return response.data
  }

  buildDestinationReturningFilter(filterList, code, type) {
    let filterCountriesList
    switch (type) {
      case 'country':
        filterCountriesList = filterList.filter(item => item.country === code)
        break
      case 'city':
        filterCountriesList = filterList.filter(item => item.city === code)
        break
      case 'hotel':
        filterCountriesList = filterList.filter(item => item.code === code)
        break
      default:
        filterCountriesList = {}
        break
    }

    if (filterCountriesList.length > 0) {
      return { name: filterCountriesList[0].name, type: type, country: filterCountriesList[0].country, city: filterCountriesList[0].city, code: filterCountriesList[0].code }
    }
    return {}
  }

  isDestinationParamOk(destinationFilter) {
    return Object.keys(destinationFilter).length > 0
  }

  isOccupancyParamOk(occupancy) {
    const rooms = occupancy.rooms.filter(room => room.adults > ROOM_CAPACITY - room.children || room.children > ROOM_CAPACITY - room.adults)
    return rooms.length === 0
  }

  areCheckinAndCheckoutDatesOk(checkInDate, checkOutDate) {
    return moment(checkInDate, DateFactory.DatePatterns.DEFAULT, true).isValid() && moment(checkOutDate, DateFactory.DatePatterns.DEFAULT, true).isValid()
  }

  isDateBetweenDates(checkDate, startDate, endDate) {
    return DateFactory.formatDate(checkDate) >= DateFactory.formatDate(startDate) && DateFactory.formatDate(checkDate) <= DateFactory.formatDate(endDate)
  }

  isTodayBetweenStayDates(promotion) {
    return DateFactory.formatDate(DateFactory.today()) >= DateFactory.formatDate(promotion.stayStartDate) && DateFactory.formatDate(DateFactory.today()) <= DateFactory.formatDate(promotion.stayEndDate)
  }

  async getHotelsAvailability(params) {
    const config = {
      headers: {
        'x-currency': window.Cookie.read(window.cookieDictionary.preferredCurrency)
      }
    }
    if (params) {
      const url = `${availabilityApi}/multiple-price-from?${params}`
      const { data } = await this.httpClient.get(url, config)
      return data
    }
  }

  async getHotelGalleries(codes) {
    const url = `${contentApi}/hotels?hotelCodes=${codes}`
    const { data } = await this.httpClient.get(url)
    return data
  }

  getHotelsCode(hotels) {
    return hotels.map(hotel => hotel.code)
  }

  filterRequestedHotels(allHotels, hotelCodes, field) {
    return hotelCodes.filter(
      code => !allHotels.find(hotel => hotel.code === code)?.[field]
    )
  }

  stayStartDateIsBeforeToday(stayStartDate) {
    return DateFactory.formatDate(stayStartDate) < DateFactory.formatDate(DateFactory.today())
  }

  getDefaultFilterDates(promotion) {
    if (this.isTodayBetweenStayDates(promotion)) {
      return {
        start: DateFactory.formatDate(DateFactory.today()),
        end: DateFactory.formatDate(DateFactory.addDays(DateFactory.today(), this.getMinLenghtOfStay(promotion)))
      }
    } else {
      if (this.stayStartDateIsBeforeToday(promotion.stayStartDate)) {
        return {
          start: DateFactory.formatDate(DateFactory.today()),
          end: DateFactory.formatDate(DateFactory.addDays(DateFactory.today(), this.getMinLenghtOfStay(promotion)))
        }
      } else {
        return {
          start: DateFactory.formatDate(promotion.stayStartDate),
          end: DateFactory.formatDate(DateFactory.addDays(DateFactory.formatDate(promotion.stayStartDate), this.getMinLenghtOfStay(promotion)))
        }
      }
    }
  }

  getMinLenghtOfStay(promotion) {
    return promotion.minLengthOfStay ? promotion.minLengthOfStay : 1
  }

  handlePreventCloseModals(modal) {
    const modals = '#modal-add-promocode, #modal-rewards-login-discovery, #modal-expired-promocode, #modal-owner-not-correct, #modal-invalid-credentials-error'
    /* eslint-disable */
    const modalNodeList = document.querySelectorAll(modals)
    modalNodeList?.forEach(elem => elem.setAttribute('data-backdrop', 'static'))
    modalNodeList?.forEach(elem => elem.setAttribute('data-keyboard', 'false'))
    modalNodeList?.forEach(elem => elem.getElementsByClassName('close')[0]?.remove())

    $('#' + modal).modal('show')
    /* eslint-disable */
  }
}
